import { create } from 'zustand';

export type ThemeMode = 'light' | 'dark' | 'system';

interface ThemeState {
  theme: ThemeMode;
  setTheme: (theme: ThemeMode) => void;
}

function getStoredTheme(): ThemeMode {
  try {
    const stored = localStorage.getItem('theme-storage');
    if (stored) {
      const parsed = JSON.parse(stored);
      if (parsed?.state?.theme) {
        return parsed.state.theme as ThemeMode;
      }
    }
  } catch {
    // ignore
  }
  // The approved product surface is a warm paper/light ledger. Users can still
  // explicitly choose "跟随系统" from settings when they want adaptive mode.
  return 'light';
}

export const useThemeStore = create<ThemeState>((set) => ({
  theme: getStoredTheme(),
  setTheme: (theme) => {
    try {
      localStorage.setItem('theme-storage', JSON.stringify({ state: { theme } }));
    } catch {
      // ignore
    }
    set({ theme });
  }
}));

export function getResolvedTheme(theme: ThemeMode): 'light' | 'dark' {
  if (theme === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return theme;
}
